import React from 'react';
import SysJobsContainer from '../../containers/sysjobs/SysJobsContainer';

const SysJobsPage = () => {
  return <SysJobsContainer />;
};

export default SysJobsPage;
